import clsx from 'clsx';
import * as React from 'react';
import { match } from 'ts-pattern';
import { breakPoints } from '@ovpn-ui/styles';
import { useMediaQuery } from '@ovpn-ui/utils';
import * as Styled from './Text.styles';
import { defaultElement } from './Text.props';
import { jsx as _jsx } from "react/jsx-runtime";
const matchDefaultElement = variant => match(variant).with('textXs', 'textSm', 'textMd', () => defaultElement).with('textLg', () => 'h3').with('displaySm', () => 'h2').otherwise(() => 'h1');
const Text = /*#__PURE__*/React.forwardRef(function Text({
  variant = 'textSm',
  color = 'inherit',
  weight,
  as,
  inline = true,
  className,
  children,
  ...props
}, ref) {
  const isMd = useMediaQuery(`(min-width: ${breakPoints.MD}px)`);
  return /*#__PURE__*/_jsx(Styled.Text, {
    ref: ref,
    forwardedAs: as || matchDefaultElement(variant),
    className: clsx(`ovpn-text-${variant.toLowerCase()}`, className),
    isMd: isMd,
    $color: color,
    $weight: weight,
    $variant: variant,
    $inline: inline,
    ...props,
    children: children
  });
});
export default Text;